export const mutations = {
  setAccessToken (state, payload) {
    state.accessToken = payload
  },
  setRefreshToken (state, payload) {
    state.refreshToken = payload
  },
  setExpiryTokenDate (state, payload) {
    state.expiryTokenDate = payload
  },
  setTokenType (state, payload) {
    state.tokenType = payload
  },
  setPayload (state, payload) {
    state.payload = payload
  },
  setUser (state, payload) {
    state.user = payload
  },
  setCurrentRole (state, payload) {
    state.currentRole = payload
  },
  setResourcesPermissions (state, payload) {
    state.resourcesPermissions = payload
  },
  setAuthenticatePending (state) {
    state.isAuthenticatePending = true
  },
  unsetAuthenticatePending (state) {
    state.isAuthenticatePending = false
  },
  setAuthenticateError (state, error) {
    state.errorOnAuthenticate = Object.assign({}, error)
  },
  clearAuthenticateError (state) {
    state.errorOnAuthenticate = null
  },
  logout (state) {
    state.payload = null
    state.accessToken = null
    state.refreshToken = null
    state.expiryTokenDate = null
    state.tokenType = null
    state.user = null
  }
}
